import { render } from "./DialogAddGuest.vue?vue&type=template&id=e445a328&ts=true"
import script from "./DialogAddGuest.ts?vue&type=script&lang=ts"
export * from "./DialogAddGuest.ts?vue&type=script&lang=ts"

import "./DIalogAddGuest.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__